import Switch from "@mui/material/Switch";
import styled from "styled-components";
import { colors } from "healthex-common/colors";
export const HXToggleSwitchEl = styled(Switch) `
    &.MuiSwitch-root {
        margin-left: auto;
        width: ${(props) => 82 * props.scale}px;
        height: ${(props) => 41 * props.scale}px;
        padding: ${(props) => 8 * props.scale}px;
    }

    & .MuiSwitch-switchBase {
        color: ${colors.white_main};
        padding: ${(props) => 3 * props.scale}px ${(props) => 5 * props.scale}px;
    }
    & .MuiSwitch-switchBase.Mui-checked {
        color: ${colors.navy_main};
        transform: translateX(${(props) => 38 * props.scale}px);
    }

    & .MuiSwitch-switchBase.Mui-checked.Mui-disabled {
        color: ${colors.navy_50_opaque};
    }

    & .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
        background-color: ${colors.navy_main};
        opacity: 0.5;
    }

    & .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track {
        opacity: 0.3;
    }

    & .MuiSwitch-thumb {
        width: ${(props) => 34 * props.scale}px;
        height: ${(props) => 34 * props.scale}px;
    }

    & .MuiSwitch-track {
        position: relative;
        &:before {
            content: "yes";
            font-size: ${(props) => 14 * props.scale}px;
            position: absolute;
            top: 0;
            left: ${(props) => 5 * props.scale}px;
            height: ${(props) => 25 * props.scale}px;
            line-height: ${(props) => 25 * props.scale}px;
            color: white;
            text-transform: uppercase;
        }

        &:after {
            content: "no";
            font-size: ${(props) => 14 * props.scale}px;
            position: absolute;
            top: 0;
            right: ${(props) => 8 * props.scale}px;
            height: ${(props) => 25 * props.scale}px;
            line-height: ${(props) => 25 * props.scale}px;
            color: white;
            text-transform: uppercase;
        }
    }
`;
